import React from "react";
import { ShadowBtn } from "./shadowButtonStyle";

const ShadowButton = (props) => {
    return <ShadowBtn {...props}>{props.children}</ShadowBtn>;
};

export default ShadowButton;
